import { SpanPolitics } from 'components/birthday-input/style.custom'
import { Link } from 'react-router-dom'
import { GenericText } from 'views/memorama/views/list/styles/custom'

const Arrow = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12.5" cy="12.5" r="9.5" fill="white" />
      <path d="M12.5 2.46875C14.3392 2.46875 16.0482 2.93262 17.627 3.86035C19.1569 4.75553 20.3695 5.9681 21.2646 7.49805C22.1924 9.07682 22.6562 10.7858 22.6562 12.625C22.6562 14.4642 22.1924 16.1732 21.2646 17.752C20.3695 19.2819 19.1569 20.4945 17.627 21.3896C16.0482 22.3174 14.3392 22.7812 12.5 22.7812C10.6608 22.7812 8.95182 22.3174 7.37305 21.3896C5.8431 20.4945 4.63053 19.2819 3.73535 17.752C2.80762 16.1732 2.34375 14.4642 2.34375 12.625C2.34375 10.7858 2.80762 9.07682 3.73535 7.49805C4.63053 5.9681 5.8431 4.75553 7.37305 3.86035C8.95182 2.93262 10.6608 2.46875 12.5 2.46875ZM12.5 4.03125C10.9375 4.03125 9.48893 4.42188 8.1543 5.20312C6.86849 5.9681 5.8431 6.99349 5.07812 8.2793C4.29688 9.61393 3.90625 11.0625 3.90625 12.625C3.90625 14.1875 4.29688 15.6361 5.07812 16.9707C5.8431 18.2565 6.86849 19.2819 8.1543 20.0469C9.48893 20.8281 10.9375 21.2188 12.5 21.2188C14.0625 21.2188 15.5111 20.8281 16.8457 20.0469C18.1315 19.2819 19.1569 18.2565 19.9219 16.9707C20.7031 15.6361 21.0938 14.1875 21.0938 12.625C21.0938 11.0625 20.7031 9.61393 19.9219 8.2793C19.1569 6.99349 18.1315 5.9681 16.8457 5.20312C15.5111 4.42188 14.0625 4.03125 12.5 4.03125ZM13.0615 7.62012L18.0664 12.625L13.0615 17.6299L11.9385 16.5312L15.0635 13.4062H7.03125V11.8438H15.0635L11.9385 8.71875L13.0615 7.62012Z" fill="#B69152" />
    </svg>
  )
}

export const languageES = {
  redeem: {
    description: "EMPIEZA A GANAR PUNTOS Y LLÉVATE PREMIOS ÚNICOS",
    description2: <span className='industry text-white text-base'>RESUELVE LAS PISTAS DEL TOTEM, INGRESA EL CÓDIGO Y FÍJATE SI ACIERTAS</span>
  },
  legalage: {
    title: ' ',
    button1: <span>SI, SOY MAYOR</span>,
    button2: <span>NO, SOY MENOR</span>,
    question: '¿Eres mayor de edad?',
    politics: ' '
  },
  mail: {
    title: <>¡EXCELENTE, name!</>
  },
  password: {
    title: 'RESETEAR CONTRASEÑA',
    label: {
      newPassword: 'Nueva contraseña',
      newPasswordConfirm: 'Confirmar nueva contraseña'
    }
  },
  agegate: {
    title: <></>,
    description: <>
      <img src={`${AZURE_BASE_URL}/nochebuena_logo.webp`} alt='bienvenida agegate' className='mx-auto w-full max-w-md px-7' />
      <h1 className='oswald font-medium text-center mt-4 mb-2 px-7' style={{ color: '#F2D194', fontSize: '22px', lineHeight: '26px' }}>¡Estás a un paso de descubrir el intercambio de la temporada!</h1>
      <p className='acumin-pro text-sm font-normal text-white text-center normal-case px-7'>Primero ingresa tu fecha de nacimiento, queremos validar tu mayoría de edad.</p>
    </>,
    politics1: <span className='hidden'></span>,
    politics2: <SpanPolitics>
      AL ENVIAR ESTE FORMULARIO, ACEPTAS LA <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">POLÍTICA DE PRIVACIDAD</a >, <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">TÉRMINOS Y CONDICIONES Y USO DE COOKIES</a > DE ESTE SITIO WEB.<br /><br /> ESTE SITIO WEB UTILIZA COOKIES. PARA OBTENER MÁS INFORMACIÓN, LEE NUESTRA POLÍTICA DE <a href={`${process.env.PUBLIC_URL}/privacy-politics`} rel="noreferrer" target="_blank" className="underline">PRIVACIDAD</a > Y USO DE <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">COOKIES</a >.
    </SpanPolitics>,
    button: 'Ingresar'
  },
  signup: {
    welcome: {
      subtitle: 'Nos falta validar tu cuenta.',
      description: <span>Te enviamos un código de 6 dígitos a tu correo electrónico EMAIL para que lo ingreses y valides tu cuenta</span>,
      description2: <></>,
      description3: <><b>¿No te llegó ningún correo?</b><br />Intentémoslo de nuevo,<br /></>,
      'button-resend': 'Da clic aquí para reenviarlo',
      button: 'Verificar cuenta'
    },
    button: 'Terminar registro',
    title: 'Bienvenido',
    description:
      'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar tus latas para completar la colección. Consigue las 26 latas de Amstel Ultra y descubre los mensajes de Rafa Nadal.'
    ,
  },
  start: {
    signup: 'Registrarse con correo',
    signin: 'Entra con correo',
    social: 'Entra con:',
    xeerpa: {
      title: 'Ingresa a tu bohemia id o crea tu cuenta para obtenerlo.'
    },
    title: {
      html: (
        <div className="flex-1 w-full pt-4 px-7 flex flex-col items-center justify-center">
          <img src={`${AZURE_BASE_URL}/fondo-inicial.webp`} alt="background" className="w-full" />
        </div>
      )
    }
  },
  groups: {
    start: {
      onboarding: {
        button: '¡Quiero participar!',
        1: {
          subtitle: 'Intercambio Noche Buena',
        },
        list: (
          <>
            <img src={`${AZURE_BASE_URL}/groups-header.webp`} />
            <ul className="flex-1 items-center justify-center flex-col flex w-full gap-6 pb-7">
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-2.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p style={{ color: '#F8F6F1' }} className="font-normal roboto text-sm">
                    <b style={{ color: '#D9CBB0' }}>Crea un intercambio con tu propio grupo de personas</b>
                    <br />
                    Invita a tu grupo y prepara todo para descubrir a tu amigo secreto.
                  </p>
                </div>
              </li>
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-1.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p style={{ color: '#F8F6F1' }} className="font-normal roboto text-sm">
                    <b style={{ color: '#D9CBB0' }}>Arma tu wishlist con tus regalos favoritos</b>
                    <br />
                    Pon tu top 3 de regalos que te gustaría recibir de parte de tu amigo secreto.
                  </p>
                </div>
              </li>
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-3.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p style={{ color: '#F8F6F1' }} className="font-normal roboto text-sm">
                    <b style={{ color: '#D9CBB0' }}>Participa como invitado en otros intercambios</b>
                    <br />
                    Puedes ser parte de otros intercambios en grupos donde te inviten.
                  </p>
                </div>
              </li>
            </ul>
          </>
        )
      },
      title: 'Intercambios',
      'not-found-owner': 'Para armar un intercambio tienes que crear un grupo primero ¿Qué esperas? ¡Vamos a crearlo!',
      'not-found': 'Para armar un intercambio tienes que crear un grupo primero ¿Qué esperas? ¡Vamos a crearlo!',
      create: {
        label: 'Dale un nombre al grupo',
        placeholder: 'Nombre del grupo'
      }
    },
    details: {
      'share-text': 'Llegó la temporada para traer lo mejor a la mesa, reunirnos con los nuestros y regalar algo de corazón. Te invito a participar en el intercambio de Noche Buena. ¡Únete al grupo para comenzar!',
      'invite-participant': '¡Qué buen grupo! Te recomendamos que para que la dinámica sea más divertida agregues más integrantes con el siguiente botón:',
      edit: {
        description: 'Puedes editar el nombre del grupo, el avatar y la lista de integrantes para quitar miembros. Ten en cuenta que si eliminas un integrante no podrá participar en el intercambio.',
        button: 'Finalizar'
      }
    },
  },
  home: {
    description: '¡Completa tus datos!',
    popup: {
      two: {
        mobile: `${AZURE_BASE_URL}/popup-2-mobile.webp`,
        desktop: `${AZURE_BASE_URL}/popup-2-desktop.webp`,
        'desktop-1500': `${AZURE_BASE_URL}/popup-2-desktop-1500.webp`,
      }
    }
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '¿Cómo te llamas?',
          placeholder: 'Pon tu nombre aquí'
        },
        lastname: {
          placeholder: 'Pon tu apellido aquí'
        },
        nickname: {
          label: '¿Apodo? (Opcional)',
          placeholder: '¿Cómo te gusta que te llamen?'
        },
        gender: {
          label: '¿Cómo te identificas?',
          placeholder: 'Selecciona una opción'
        },
        birthdate: {
          label: '¿Fecha de nacimiento?'
        },
        email: {
          label: '¿E-mail?'
        },
        password: {
          label: '¿Contraseña?'
        },
        referral: {
          label: 'INGRESA TU CÓDIGO REFERIDO'
        },
        names: {
          button: 'Siguiente'
        },
        ageGender: {
          button: 'Siguiente'
        }
      }
    },
    information: 'DATOS PERSONALES',
    address: 'DIRECCIÓN',
    contact: 'CONTACTO',
    button: 'IR A VER LOS PREMIOS',
    state: 'HISTORIAL DE CANJES',
    identification: {
      nav: 'MI BOHEMIA ID',
      label: 'Mi Bohemia ID',
      button: 'Descargar ID'
    },
    view: {
      contact: {
        update: 'Actualizar'
      },
      arrow: <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.45117 0.107422L10.7988 1.45508L4.44141 7.8125H23.25V9.6875H4.44141L10.7988 16.0449L9.45117 17.3926L1.48242 9.42383L0.837891 8.75L1.48242 8.07617L9.45117 0.107422Z" fill="black" />
      </svg>
    }
  },
  login: {
    button: 'Ingresar'
  },
  config: {
    prizes: '/prizes'
  },
  congrats: {
    description: <>Tu foto se ha subido con éxito.<br />Has acumulado los siguientes puntos en tu cuenta:</>,
    button1: 'VAMOS A VER LOS PREMIOS',
    button2: 'QUIERO INGRESAR OTRA FOTO',
    'button2Link': '/album/redirect/Foto/upload',
    range: {
      title: 'NUEVO LOGRO DESBLOQUEADO',
      description: <></>,
      description2: (
        <>
          Felicitaciones, has desbloqueado nuevos <br /> premios y obtienes más chances de ganar.
        </>
      )
    }
  },
  backButton: 'Volver',
  endroute: {
    icon: <svg xmlns="http://www.w3.org/2000/svg" width="107" height="32" viewBox="0 0 107 32" fill="none" className='mx-auto mb-10'>
      <g clipPath="url(#clip0_274_2712)">
        <path d="M105.149 8.5898C104.441 7.8789 103.805 7.78443 103.385 8.08202C102.507 8.74804 102.446 10.5619 101.71 12.4159C101.013 14.2865 99.7303 16.6908 97.7602 18.3133C96.8921 19.0715 95.0569 20.5004 91.8917 21.438C91.1246 21.6671 90.2843 21.8796 89.3944 22.0709C90.1198 20.5995 90.6272 18.925 90.752 17.1773C91.1088 12.3734 89.2933 7.78443 86.3541 4.57711C84.6119 2.69948 82.5547 1.53511 80.4934 0.821851C78.4322 0.129844 76.4027 -0.0638232 74.5911 0.0188397C70.9483 0.188889 68.1835 1.4123 66.8675 2.11139C63.6408 3.87093 61.3596 6.36735 60.0376 8.4599C58.7176 10.5761 58.2955 12.364 58.9039 13.311C59.5184 14.2676 61.0762 14.1873 63.0581 13.4457C65.048 12.7088 67.4323 11.3555 69.882 10.0305C70.9225 9.48256 72.7658 8.32056 75.2789 7.69232C77.7544 7.04283 80.975 7.07117 83.5873 8.87558C85.8665 10.4462 87.682 13.6559 87.676 16.9647C87.7038 18.6062 87.2103 20.2382 86.3541 21.6789C86.1341 22.0473 85.8903 22.4016 85.6267 22.7393C83.8687 22.992 82.0255 23.1857 80.1842 23.3109C76.4086 23.5542 72.5497 23.3581 68.7067 22.711C64.8637 22.0709 61.0464 20.9349 57.2748 19.4989C52.0067 17.4843 47.0954 15.2453 42.3863 13.2945C37.6811 11.3319 33.1662 9.66206 28.8218 8.51895C24.4793 7.36875 20.3033 6.75469 16.3751 6.7169C14.409 6.69092 12.5142 6.85624 10.6868 7.10187C8.85552 7.3782 7.04599 7.84111 5.397 8.74332C3.74999 9.61955 2.28334 11.0083 1.31813 12.7159C0.339043 14.3998 -0.172302 16.5065 0.0516593 18.4787C0.263729 20.4508 1.08624 22.1324 2.06137 23.3747C3.03451 24.6429 4.15828 25.557 5.27808 26.2844C9.86235 29.0335 14.185 29.0382 17.4949 28.4856C20.8484 27.9093 23.3119 26.5773 25.1135 25.3798C26.9171 24.1541 28.0805 22.9897 28.8634 22.0969C29.6601 21.2183 30.0704 20.5877 30.3261 20.2264C30.5738 19.8603 30.6531 19.7422 30.6531 19.7422C30.6531 19.7422 30.556 19.8414 30.2587 20.1508C29.9614 20.4626 29.4917 21.0176 28.6414 21.7875C27.805 22.5693 26.5941 23.5896 24.7865 24.6359C22.9829 25.6585 20.561 26.7733 17.3561 27.1488C15.7626 27.3378 13.9789 27.3637 12.0485 27.0189C10.1398 26.6646 8.02112 25.975 6.0451 24.6429C5.06601 23.9604 4.09882 23.1149 3.31991 22.0379C2.53109 20.9774 1.9583 19.6643 1.83542 18.2425C1.55795 15.3871 3.43883 12.2577 6.21555 10.9115C7.08563 10.4674 8.04292 10.1533 9.04975 9.91713C10.9465 9.7707 13.5587 9.74472 17.1441 10.3186C19.897 10.7579 23.2029 11.6129 27.0558 13.1882C30.9127 14.7588 35.273 17.1655 40.333 20.224C42.8679 21.7427 45.5911 23.4124 48.5878 25.0822C51.5826 26.7379 54.8568 28.4384 58.5353 29.7303C62.198 31.034 66.259 31.9858 70.6649 31.9999C74.4921 32.0047 78.6383 31.2347 82.5665 28.991C83.9817 29.1256 85.3869 29.2319 86.7485 29.2721C88.9029 29.3382 91.0176 29.3028 93.0115 29.0382C95.0014 28.7785 96.8644 28.2754 98.4163 27.5928C99.9721 26.9126 101.199 26.0742 101.99 25.4034C103.992 23.7573 105.436 21.3884 106.203 19.114C107 16.8159 107.153 14.4683 106.875 12.5836C106.578 10.68 105.868 9.2889 105.153 8.59217L105.149 8.5898ZM70.653 29.0619C66.5662 29.0926 62.7053 28.2541 59.1874 27.0591C55.6615 25.8782 52.4646 24.2934 49.4916 22.7228C46.5226 21.1428 43.7836 19.5462 41.209 18.089C36.0718 15.1556 31.5529 12.8458 27.5434 11.398C25.9876 10.8359 24.5467 10.4131 23.1672 10.0588C24.846 10.3635 26.5544 10.739 28.3065 11.2256C32.5161 12.3923 36.9161 14.0692 41.5677 16.0578C46.2234 18.0346 51.1386 20.3138 56.4939 22.3945C60.327 23.8754 64.2096 25.2476 68.1498 26.308C71.0494 27.0945 73.9728 27.6849 76.9001 28.1833C74.8072 28.7832 72.6885 29.0453 70.651 29.0595L70.653 29.0619Z" fill="#E5E4E3" />
      </g>
      <defs>
        <clipPath id="clip0_274_2712">
          <rect width="107" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>,
    title: (
      <>
        ¡Lo sentimos! <br /> Esto es solo <br /> para mayores
      </>
    ),
    description: 'Vuelve cuando seas mayor de edad.'
  },
  referrals: {
    description: 'Comparte tu código con amigos y gana más oportunidades de ganar.',
    subtitle: 'COMPARTE TU CÓDIGO Y GANA',
    left: 'COPIAR',
    right: 'COMPARTIR'
  },
  allowcookies: {
    subtitle: 'INGRESA TU CÓDIGO REFERIDO',
    button: 'Siguiente'
  },
  trivias: {
    exchange: {
      button: {
        text: 'Seguir jugando',
        url: '/trivias'
      }
    },
    triviaQr: {
      register: {
        html: (
          <div className='flex-1 space-y-6 mt-8'>
            <img src={`${AZURE_BASE_URL}/trivia-qr-card-id.webp`} alt="Bohemia ID" className='px-4' />
            <h2>
              <span style={{ color: '#AE8754' }}>Contesta</span> <span style={{ color: '#D09B34' }}>y gana</span>
            </h2>
            <div>
              <h3>¿Ya tienes tu ID?</h3>

              <p className="mt-2">
                Si no lo tienes córrele a registrarte <br /> para poder participar.
              </p>
            </div>
          </div>
        ),
        title: 'CONTESTA Y GANA',
        button: 'Comencemos',
        typeImage: 'png'
      },
      late: {
        title: '¡UPS! YA ES TARDE',
        description: (
          <p className="">
            Lamentablemente esta trivia ya no está disponible. Estate atento para contestar una trivia nueva.
          </p>
        ),
        button: {
          text: 'VER MÁS DINÁMICAS'
        }
      }
    },
    questions1: <>Contesta </>,
    questions2: (
      <>
        {' '}
        <span className="font-bold">
          preguntas
        </span>{' '}
        sobre el tema y gana:
      </>
    ),
    "not-found": "No hay trivias disponibles por el momento",
    "exit": {
      "cancel": "NO, VOLVER",
      "subtitle": "Si cancelas ahora se perderá tu progreso y tendrás que volver a empezar. "
    }
  },
  survey: {
    title: 'CUÉNTANOS DE TI',
    button: 'Contestar'
  },
  prizes: {
    start: {
      title: <span>PREMIOS</span>
    },
    congrats: {
      description: <>Revisa tu email que te vamos a mandar <br /> toda la info del envío de tu canje <br /> ¡Felicidades!</>
    },
    btn: {
      text: 'CANJEAR',
    },
    exchange: {
      button: 'SI CLARO',
      buttonBack: 'VOLVER',
      warning: <>¿Segurísimo que quieres este premio?</>
    }
  },
  album: {
    title: 'RETOS',
    notFound: 'No hay retos activos en este momento',
    states: {
      progress: 'ACTUALES',
      completed: 'PASADOS'
    }
  },
  cardid: {
    bottom: '40px'
  },
  social: {
    Foto: {
      howToParticipate: {
        title: '¿CÓMO PARTICIPAR?',
        subtitle: <>GANA UNA PIZZA MASTER CLASS <br /> <div>ESTA EXPERIENCIA ESTÁ DISPONIBLE <b style={{ fontWeight: 600 }}>ÚNICAMENTE PARA CDMX</b> POR EL MOMENTO ¡MUY PRONO TAMBIÉN EN OTRAS CIUDADES!</div></>,
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-1.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-bold text-base dinCondensed" style={{ color: '#D39052' }}>
                  COMPLETA TUS DATOS PERSONALES
                </p>
                <p className="font-normal text-base acumin-pro" style={{ color: 'white' }}>
                  Crea tu cuenta y completa tu perfil.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-7.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="font-bold text-base dinCondensed" style={{ color: '#D39052' }}>
                  SUBE UNA FOTO DE TU MARIDAJE
                </p>
                <p className="font-normal text-base acumin-pro" style={{ color: 'white' }}>
                  Donde se vea tu pizza favorita y la Bohemia con la que maridas.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-5.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="text-base dinCondensed font-bold" style={{ color: '#D39052' }}>
                  INVITA A VOTAR A TUS AMIGOS
                </p>
                <p className="font-normal text-base acumin-pro" style={{ color: 'white' }}>
                  Comparte tu foto para que voten por tí y quedar más arriba en el ranking.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-6.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p className="text-base dinCondensed font-bold" style={{ color: '#D39052' }}>
                  LAS 5 FOTOS MÁS VOTADAS
                </p>
                <p className="font-normal text-base dinCondensed" style={{ color: 'white' }}>
                  ¡GANAN!
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">
                    No mostrar la marca en un entorno de exceso, peligro o violencia.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">
                    No mostrar otras marcas de cerveza.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">
                    No aparecer fumando.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">No aparecer con consumo excesivo o aparentemente excesivo de bebidas alcohólicas.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">No aparecer con menores de edad.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">Puedes subir un máximo de 4 imágenes para la dinámica.</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">Luego de subir tu primer consumo tienes que esperar períodos de a 15 minutos acumulativos cada vez que subas tus consumos. (Es decir la segunda vez que subes son 15’, luego 30’ y luego 45’).</p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="text-black font-normal acumin-pro text-base">La dinámica para ganar el premio de la PIZZA MASTERCLASS con el Chef Cesar De La Parra está únicamente disponible para usuarios de CDMX por el momento. Ver los <Link to='/terms-and-conditions' className='underline'>Términos y Condiciones</Link> para más información.</p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        'subtitle': 'Clic para subir tu imagen',
        'ranking-subtitle': {
          progress: <> Este es el ranking con las fotos más votadas. < br /> Dale clic a la que más te guste para votarla.</>,
          completed: <>Este reto ya ha finalizado y no se puede votar, <br /> Selecciona un rally para ver los ganadores.</>
        },
        rules: {
          title: 'CÓMO SUBIR EL CONTENIDO',
          list: (
            <ul style={{ color: '#000', fontSize: '13px', fontFamily: 'Roboto' }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Usa la cámara de tu celular para tomar la foto de tu maridaje favorito de pizza y Bohemia.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Busca un lugar iluminado para tomar la foto.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Mantente quieto al momento de tomar la foto para obtener una imagen de buena calidad.
                </p>
              </li>
            </ul>
          )
        },
        errorModalValidate: {
          description: <>Aún no puedes subir nuevo contenido por las siguientes razones:</>,
          list: <div style={{ width: '320px' }}>
            <div className="acumin-pro text-white text-sm font-normal">
              <p className='ml-5'> <span className="font-bold italic text-base">• Llegaste al máximo de contenido que puedes cargar.</span> (puedes subir máx. 4 veces)</p>
            </div>
            <div className="acumin-pro text-white text-sm font-normal">
              <p className='ml-5'> <span className="font-bold italic text-base">• Aún no pasaron los minutos desde que subiste tu contenido.</span> (Son 15 minutos acumulativos desde que subes tu primera foto)</p>
            </div>
          </div>,
          help: <div style={{ width: '320px' }} className='flex justify-center items-center flex-col mb-12 acumin-pro'>
            <span className="font-bold text-white text-center text-sm acumin-pro">¿Te parece que no es así?</span>
            <span className="text-center text-white text-sm acumin-pro">Ponte en contacto con nosotros para que <br /> podamos ayudarte. <Link to="/help" className='underline'>Envíanos un mensaje.</Link> </span>
          </div>
        },
        alreadyUploaded: {
          title: 'IMAGEN VALIDADA CON ÉXITO.',
          description: <>Recuerda que Esta experiencia está disponible únicamente para CDMX por el momento.<br />
            Ver los <Link to='terms-and-conditions' className='underline'>Términos y Condiciones</Link> para más información.</>,
          button: {
            url: '/album/redirect/Foto/ranking',
            text: 'VER RANKING'
          },
          buttonBack: {
            text: 'QUIERO SUBIR OTRA FOTO'
          }
        },
      }
    },
    profile: {
      title: 'MI CONTENIDO',
      nextArrow: <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17.5" cy="17.5" r="17.5" transform="rotate(180 17.5 17.5)" fill="black" />
        <path d="M25.7071 17.7071C26.0976 17.3166 26.0976 16.6834 25.7071 16.2929L19.3431 9.92893C18.9526 9.53841 18.3195 9.53841 17.9289 9.92893C17.5384 10.3195 17.5384 10.9526 17.9289 11.3431L23.5858 17L17.9289 22.6569C17.5384 23.0474 17.5384 23.6805 17.9289 24.0711C18.3195 24.4616 18.9526 24.4616 19.3431 24.0711L25.7071 17.7071ZM10 18L25 18L25 16L10 16L10 18Z" fill="white" />
      </svg>,
      prevArrow: <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17.5" cy="17.5" r="17.5" fill="black" />
        <path d="M9.29289 17.2929C8.90237 17.6834 8.90237 18.3166 9.29289 18.7071L15.6569 25.0711C16.0474 25.4616 16.6805 25.4616 17.0711 25.0711C17.4616 24.6805 17.4616 24.0474 17.0711 23.6569L11.4142 18L17.0711 12.3431C17.4616 11.9526 17.4616 11.3195 17.0711 10.9289C16.6805 10.5384 16.0474 10.5384 15.6569 10.9289L9.29289 17.2929ZM25 17L10 17V19H25V17Z" fill="white" />
      </svg>,
      button: {
        text: 'VER GANADORES',
        url: '/album/:id/ranking'
      },
      return: {
        url: '/album/:id/ranking'
      }
    },
    imgUpload: 'Espera mientras revisamos tu imagen.'
  },
  vote: {
    title: 'VOTA LA QUE MÁS TE GUSTA',
    success: <>Foto votada <br /> con éxito</>,
    btn: <>VOLVER AL RANKING</>
  },
  error: {
    79: {
      message: <>Ya has votado <br /> esta foto</>,
      description: 'Intenta con otra diferente.'
    },
    71: {
      title: <>¡Ups! <br /> el código ha <br /> expirado </>,
      description: <>Dale click en <b>REENVIAR</b> para recibir <br /> otro código e intentarlo de nuevo.</>
    },
    1114: {
      title: 'NO HEMOS PODIDO VALIDAR TU IMAGEN'
    },
    9001: {
      description: 'Podrás volver a invitarlo si lo deseas luego, siempre y cuando no hayas realizado el sorteo de nombres.',
      button: {
        text: 'Finalizar'
      }
    },
    9003: {
      title: '¿SEGURO QUIERES SALIR DEL GRUPO?',
      description: 'Si sales ahora ya no formarás parte de este grupo.',
      button: {
        text: 'Si, continuar'
      }
    },
    9002: {
      title: <>
        Has sido invitado al<br />intercambio noche buena<br /><br />
        <img src={`${AZURE_BASE_URL}/groups-invite.png`} className='w-full' />
      </>,
      description: <>
        <b>Llega la época para regalar algo de corazón y consentir a los nuestros. No podía falta Noche Buena con el icónico sabor de la temporada.</b><br /><br />
        Participa en el intercambio y disfruta esta temporada con tu grupo.
      </>,
      button: {
        text: '¡Quiero participar!'
      }
    }
  },
  otp: {
    title: <span className='text-black text-center industry text-base uppercase font-bold'>Ingresa el código de 6 dígitos QUE <br /> RECIBISTE para verificar tu celular.</span>,
    received: '¿No lo recibiste?',
    resend: 'Reenviar código',
    phone: {
      button: 'Pedir código OTP'
    }
  },
  tivias: {
    challenge: {
      modal: {
        description: <><b>¿Segurísimo que quieres empezar a jugar?</b> una vez que des click no hay vuelta atrás.</>
      }
    }
  },
  memorama: {
    list: {
      'not-found': 'No hay dinámicas disponibles por el momento, estate atento a las nuevas que tendremos próximamente.'
    },
    modal: {
      title: <>¿CÓMO PARTICIPAR?<br /><span style={{ fontSize: '16px', fontFamily: 'Oswald', lineHeight: '120%', fontWeight: 400 }}>MEMORAMA BOHEMIO</span></>,
      items: (
        <div className='flex-1'>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-1.svg`} alt="icons" />
            <GenericText className='flex-1'>
              CONCÉNTRATE Y MEMORIZA<br /><p className='acumin-pro text-base font-normal' style={{ lineHeight: '135%' }}>el orden de las imágenes que van a aparecer.</p>
            </GenericText>
          </div>
          <div className="flex gap-4 mt-10 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-2.svg`} alt="icons" />
            <GenericText className='flex-1'>
              ESTAS DESAPARECERÁN<br /><p className='acumin-pro text-base font-normal' style={{ lineHeight: '135%' }}>y debes recordar el lugar donde estaban esas imágenes.</p>
            </GenericText>
          </div>
          <div className="flex gap-4 mt-10 items-center">
            <img src={`${AZURE_BASE_URL}/memorama-instruccion-3.svg`} alt="icons" />
            <GenericText className='flex-1'>
              SI ACIERTAS EN TODAS, ¡GANAS!
            </GenericText>
          </div>
        </div>
      ),
      play: {
        description: 'Estás a punto de participar en este memorama y ganar:',
        warning: '¿Seguro que quieres empezar a jugar? Una vez que des clic no hay vuelta atrás.'
      },
    },
    exchange: {
      title: 'FELICIDADES',
      button: {
        text: 'Vamos a completar mis datos'
      }
    },
    exit: {
      accept: 'SI, CLARO',
      cancel: 'NO, VOLVER'
    }
  },
  help: {
    subtitle: 'Acá estamos para lo que necesites, checa primero en nuestras preguntas frecuentes si encuentras la respuesta.',
    subtitleMessage: 'No te preocupes, déjanos un mensaje para poderte ayudar mejor.'
  }
}